module.exports = require("./VersionDateDisplay.vue");